const URL_BASE = 'https://ued8czxws4.execute-api.ap-southeast-1.amazonaws.com/production/dictionaries'
export const apiGetDictionaries = () => URL_BASE
export const apiAddDictionary = () => URL_BASE
export const apiAddDictionaryItem = () => `${URL_BASE}/add`
export const apiUpdateDictionary = id => `${URL_BASE}/update/${id}`
export const apiRemoveDictionary = id => `${URL_BASE}/remove/${id}`
